import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { BillingHistoryComponent } from './billing-history.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [BillingHistoryComponent]
})
export class BillingHistoryModule { }



// WEBPACK FOOTER //
// ./ts/app/billing-history/billing-history.module.ts